import {combineReducers, configureStore} from "@reduxjs/toolkit";
import {authReducer} from "../features/auth/authSlice";
import {apiSlice} from "./api/apiSlice";
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {applicationReducer} from "../features/application/applicationSlice";
import {themeReducer} from "./theme/themeSlice";

/*const authMiddleware = (store) => (next) => (action) => {
    const result = next(action);

    if ( action.type?.startsWith('@@user/') ) {
        const authState = store.getState().auth;
        localStorage.setItem('auth', JSON.stringify(authState))
    }
    return result;
};*/

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth', 'theme']
}

const customReducer = combineReducers({
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    application: applicationReducer,
    theme: themeReducer
});

const persistedReducer = persistReducer(persistConfig, customReducer)


export const store = configureStore({
    reducer: persistedReducer,
    devTools: true,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(
        {
            serializableCheck:{
            ignoreActions:[
                FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER

            ]
        }
    }).concat(apiSlice.middleware)


})

export const persistor = persistStore(store)